<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card class="pa-1 mb-1">
        <v-list  class="px-1 py-0">
            <v-list-item-content class="pa-1 ma-0 body-2">
                <v-list-item-title class="title body-2">
                    Управление пользователями
                </v-list-item-title>
                <v-progress-circular
                        v-show="loading"
                        indeterminate
                        color="primary"
                        size="100"
                ></v-progress-circular>
            </v-list-item-content>
        </v-list>
        <v-card-actions class="py-0">
            <v-container fluid class="py-0">
                <v-row>
                    <v-col cols="6" class="pa-2">
                        <v-row
                                class="pa-4"
                                justify="space-between"
                        >
                            <v-col cols="8">
                                <v-treeview
                                        :active.sync="active"
                                        :items="tree"

                                        :open.sync="open"
                                        activatable
                                        color="warning"
                                        open-on-click
                                        transition
                                >
                                    <template v-slot:prepend="{ item, active }">
                                        <v-icon v-if="!item.children">account_circle</v-icon>
                                    </template>
                                    <template v-slot:label="{ item, active }">
                                        <span @click="loadClient(item.id)">{{item.name}}</span>
                                    </template>
                                </v-treeview>
                            </v-col>

                            <v-divider vertical></v-divider>

                            <v-col
                                    class="d-flex text-center"
                            >
                                <v-scroll-y-transition mode="out-in">
                                    <div
                                            v-if="!selected"
                                            class="title grey--text text--lighten-1 font-weight-light"
                                            style="align-self: center;"
                                    >
                                        Select a User
                                    </div>
                                    <!--<v-card
                                            v-else
                                            :key="selected.id"
                                            class="pt-6 mx-auto"
                                            flat
                                            max-width="400"
                                    >
                                        <v-card-text>
                                            <v-avatar
                                                    v-if="avatar"
                                                    size="88"
                                            >
                                                <v-img
                                                        :src="`https://avataaars.io/${avatar}`"
                                                        class="mb-6"
                                                ></v-img>
                                            </v-avatar>
                                            <h3 class="headline mb-2">
                                                {{ selected.name }}
                                            </h3>
                                            <div class="blue&#45;&#45;text mb-2">{{ selected.email }}</div>
                                            <div class="blue&#45;&#45;text subheading font-weight-bold">{{ selected.username }}</div>
                                        </v-card-text>
                                        <v-divider></v-divider>
                                        <v-row
                                                class="text-left"
                                                tag="v-card-text"
                                        >
                                            <v-col class="text-right mr-4 mb-2" tag="strong" cols="5">Company:</v-col>
                                            <v-col>{{ selected.company.name }}</v-col>
                                            <v-col class="text-right mr-4 mb-2" tag="strong" cols="5">Website:</v-col>
                                            <v-col>
                                                <a :href="`//${selected.website}`" target="_blank">{{ selected.website }}</a>
                                            </v-col>
                                            <v-col class="text-right mr-4 mb-2" tag="strong" cols="5">Phone:</v-col>
                                            <v-col>{{ selected.phone }}</v-col>
                                        </v-row>
                                    </v-card>-->
                                </v-scroll-y-transition>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-actions>
        <client-form
                :dialog="clientFormShow"
                :client-id="clientId"
                @close="clientFormShow = false"
        ></client-form>
    </v-card>
</template>

<script>

import { mapGetters } from 'vuex'
import ClientForm from '../client/forms/ClientForm'
export default {
    name: 'ToolMarket',
    components: {
        ClientForm
    },
    data() {
        return {
            clientFormShow: false,
            clientId: null,
            active: [],
            avatar: null,
            open: [],
            users: [],
            items: [
                {
                    id: 1,
                    name: 'Applications :',
                    children: [
                        { id: 2, name: 'Calendar : app' },
                        { id: 3, name: 'Chrome : app' },
                        { id: 4, name: 'Webstorm : app' }
                    ]
                },
                {
                    id: 5,
                    name: 'Documents :',
                    children: [
                        {
                            id: 6,
                            name: 'vuetify :',
                            children: [
                                {
                                    id: 7,
                                    name: 'src :',
                                    children: [
                                        { id: 8, name: 'index : ts' },
                                        { id: 9, name: 'bootstrap : ts' }
                                    ]
                                }
                            ]
                        },
                        {
                            id: 10,
                            name: 'material2 :',
                            children: [
                                {
                                    id: 11,
                                    name: 'src :',
                                    children: [
                                        { id: 12, name: 'v-btn : ts' },
                                        { id: 13, name: 'v-card : ts' },
                                        { id: 14, name: 'v-window : ts' }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 15,
                    name: 'Downloads :',
                    children: [
                        { id: 16, name: 'October : pdf' },
                        { id: 17, name: 'November : pdf' },
                        { id: 18, name: 'Tutorial : html' }
                    ]
                },
                {
                    id: 19,
                    name: 'Videos :',
                    children: [
                        {
                            id: 20,
                            name: 'Tutorials :',
                            children: [
                                { id: 21, name: 'Basic layouts : mp4' },
                                { id: 22, name: 'Advanced techniques : mp4' },
                                { id: 23, name: 'All about app : dir' }
                            ]
                        },
                        { id: 24, name: 'Intro : mov' },
                        { id: 25, name: 'Conference introduction : avi' }
                    ]
                }
            ],
            loading: true
        }
    },
    props: [],
    methods: {
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        },
        selected () {
            if (!this.active.length) return undefined

            const id = this.active[0]
            return 1
        },
        loadClient(clientId) {
            this.clientId = clientId
            let client
            if (this.$store.state.clients.clients.length > 0) {
                client = this.$store.state.clients.clients.find(client => client.user_id === clientId)
            }
            if (!client) {
                this.$store.dispatch('clients/getClient', { user_id: clientId }).then(response => {
                    this.clientFormShow = true
                })
            } else {
                this.clientFormShow = true
            }
        }
    },
    computed: {
        ...mapGetters({
            moduleGroups: 'api/moduleGroups',
            getBotById: 'bots/getBotById',
            loadedBots: 'bots/loadedBots'// ,
            // tree: 'clients/tree'
        }),
        tree() {
            return this.$store.state.clients.tree.filter(branch => branch.children)
        }
    },
    watch: {

    },
    created() {
        this.$store.dispatch('clients/getTree', { bot_id: this.$route.params['pathMatch'] }).then(() => {
            this.loading = false
        })
    }
}
</script>

<style scoped>

</style>
